import { Dispatch, SetStateAction, useEffect, useState } from "react";

import { useUserInfoContext } from "@/contexts";
import authAxiosInstance from "@/sevices/authAxiosInstance";
import { InvoiceBalanceSummary } from "@/types/Invoice";

export const useInvoiceSummary = () => {
  const [summaryData, setSummaryData] = useState<InvoiceBalanceSummary>({
    total: "0.00",
    currency: "USD",
    credits: "0.00",
    shipToAddresses: []
  });
  const [isLoadingSummary, setIsLoadingSummary] = useState(false);
  const [showSummaryError, setShowSummaryError] = useState(false);

  const { userInfo } = useUserInfoContext() as {
    userInfo: { userId: string };
    setUserInfo: Dispatch<SetStateAction<{ userId: string }>>;
  };
  const userId = userInfo?.userId;

  useEffect(() => {
    if (userId) {
      fetchSummary();
    }
    // only fetch summary data once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const fetchSummary = async () => {
    setIsLoadingSummary(true);
    setShowSummaryError(false);

    try {
      const response = await authAxiosInstance({
        url: "/invoiceservice/api/v1/invoices/summary",
        method: "POST",
        data: { userId }
      });
      setSummaryData(response.data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error fetching summary:", err);
      setShowSummaryError(true);
    } finally {
      setIsLoadingSummary(false);
    }
  };

  return { summaryData, isLoadingSummary, showSummaryError };
};
